/**
 * Maps SVG body part IDs (from Vue Humanbody enums) to display/API region labels
 * used by PrimaryComplaintPage BODY_REGIONS.
 */
export const BODY_PART_TO_REGION: Record<string, string> = {
  // Anterior
  face: "Head",
  throat: "Neck",
  chest: "Chest",
  shoulderRight: "Shoulder Right",
  shoulderLeft: "Shoulder Left",
  armUpperLeft: "Arm Upper Left",
  armUpperRight: "Arm Upper Right",
  abdomen: "Abdomen",
  pelvis: "Abdomen",
  elbowLeft: "Elbow Left",
  elbowRight: "Elbow Right",
  forearmRight: "Forearm Right",
  forearmLeft: "Forearm Left",
  handWristLeft: "Hand / Wrist Left",
  handWristRight: "Hand / Wrist Right",
  hipRight: "Hip Right",
  hipLeft: "Hip Left",
  thighLeft: "Thigh Left",
  thighRight: "Thigh Right",
  kneeRight: "Knee Right",
  kneeLeft: "Knee Left",
  legLowerLeft: "Lower Leg Left",
  legLowerRight: "Lower Leg Right",
  ankleRight: "Ankle Right",
  ankleLeft: "Ankle Left",
  footRight: "Foot Right",
  footLeft: "Foot Left",
  ribRight: "Chest",
  ribLeft: "Chest",
  // Posterior
  neck: "Neck",
  backUpper: "Upper Back",
  backMid: "Mid Back",
  backLower: "Lower Back",
  glutRight: "Hip Right",
  glutLeft: "Hip Left",
  legUpperRight: "Thigh Right",
  legUpperLeft: "Thigh Left",
};

/** Posterior-specific labels (back of body); used when side is "posterior". */
const BODY_PART_TO_REGION_POSTERIOR: Record<string, string> = {
  armUpperLeft: "Back of Left Arm",
  armUpperRight: "Back of Right Arm",
  forearmLeft: "Back of Left Forearm",
  forearmRight: "Back of Right Forearm",
};

export type BodySide = "anterior" | "posterior";

export function partIdToRegion(partId: string, side?: BodySide): string {
  if (side === "posterior" && partId in BODY_PART_TO_REGION_POSTERIOR) {
    return BODY_PART_TO_REGION_POSTERIOR[partId];
  }
  return BODY_PART_TO_REGION[partId] ?? partId;
}
